<template>
  <div class="height-100">
    <div style="height: 50px; line-height: 50px; border-bottom: 1px solid #4f4f4f; font-weight: 450;">
      <a-row>
        <a-col :span="1"></a-col>
        <a-col :span="22">算法</a-col>
        <a-col :span="1"></a-col>
      </a-row>
    </div>
    <div class="scrollbar height-100" :style="{ height: scorllHeight + 'px'}">
      <div id="data" class=" uranus-scrollbar" v-if="algorithmDataList.length !== 0" @scroll="onScroll">
        <div v-for="item in algorithmDataList" :key="item.algorithm_id">
          <div class="panel" style="padding-top: 5px;" @click="selectAlgorithm(item)">
            <div class="title">
              <a-tooltip :title="item.algorithm_name">
                <div class="pr10" style="width: 250px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{ item.algorithm_name }}</div>
              </a-tooltip>
            </div>
            <div class="ml10 mt5 display-flex" style="color: hsla(0,0%,100%,0.65);">
              <GlobalOutlined class="mt4"/>
              <div class="ml5" style="width: 230px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">检测对象：{{ item.object_names || '无' }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <a-empty :image-style="{ height: '60px', marginTop: '60px' }" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref, watch } from 'vue'
import { ELocalStorageKey } from '/@/types'
import { Device } from '/@/types/device'
import { useMyStore } from '/@/store'
import { IPage } from '/@/api/http/type'
import { getAlgorithmByDeviceSn } from '/@/api/disposition'

const store = useMyStore()
const dock = computed<Device>(() => store.state.dockInfo || {} as Device)
const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId)!
const scorllHeight = ref()
const canRefresh = ref(true)

const algorithmDataList = ref([])
const fetchAlgoData = async () => {
  const childSn = dock.value.child_device_sn
  const res = await getAlgorithmByDeviceSn(childSn, 'cloud')
  if (res.code === 0) {
    algorithmDataList.value = res.data || []
  }
}

watch(() => dock.value.child_device_sn, (newSn) => {
  if (newSn) {
    fetchAlgoData()
  } else {
    algorithmDataList.value = []
  }
}, { immediate: true })

onMounted(() => {
  const parent = document.getElementsByClassName('scrollbar').item(0)?.parentNode as HTMLDivElement
  scorllHeight.value = document.body.clientHeight - parent.firstElementChild!.clientHeight
  fetchAlgoData()
  // getDocks()
  const key = setInterval(() => {
    const data = document.getElementById('data')?.lastElementChild as HTMLDivElement
    if (body.total === 0 || Math.ceil(body.total / body.page_size) <= body.page || scorllHeight.value + 50 <= data?.clientHeight + data?.offsetTop) {
      clearInterval(key)
      return
    }
    body.page++
    // getDocks()
    fetchAlgoData()
  }, 1000)
})
const body: IPage = {
  page: 1,
  total: -1,
  page_size: 10,
}

/* async function getDocks () {
  if (!canRefresh.value) {
    return
  }
  canRefresh.value = false

  await getBindingDevices(workspaceId, body, EDeviceTypeName.Dock).then(res => {
    if (res.code !== 0) {
      return
    }
    docksData.data.push(...res.data.list)
    body.page = res.data.pagination.page
    body.page_size = res.data.pagination.page_size
    body.total = res.data.pagination.total
  }).finally(() => {
    canRefresh.value = true
  })
} */

function onScroll (e: any) {
  const element = e.srcElement
  if (element.scrollTop + element.clientHeight >= element.scrollHeight - 5 && Math.ceil(body.total / body.page_size) > body.page && canRefresh.value) {
    body.page++
    // getDocks()
  }
}

function selectAlgorithm (algorithm) {
  store.commit('SET_SELECT_ALGORITHM_INFO', algorithm)
}

</script>

<style lang="scss" scoped>
.panel {
  background: #3c3c3c;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  height: 70px;
  width: 95%;
  font-size: 13px;
  border-radius: 2px;
  cursor: pointer;
  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 30px;
    font-weight: bold;
    margin: 0px 10px 0 10px;
  }
}
.uranus-scrollbar {
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: #c5c8cc transparent;
  height: 90%;
}
</style>
